import { createAction } from '@reduxjs/toolkit';

export const unsynchronizedChangeMade = createAction<{ projectGuid: string }>(
  'synchronization/unsynchronizedChangeMade',
);
